import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMediaQuery } from "react-responsive";

export default function Carousel(props) {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { entries } = props;
  const settings = {
    infinite: true,
    // speed: 500,
    fade: true,
    autoplaySpeed: 5000,
    autoplay: true,
    dots: true,
    draggable: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  };

  return (
    <div id="carousel">
      <Slider {...settings}>
        {entries.map((e, i) => (
          <div key={i} className="carouselEntry">
            <img
              alt={e.title}
              className={isTabletOrMobile && e.uriSquare ? "square" : "large"}
              src={isTabletOrMobile && e.uriSquare ? e.uriSquare : e.uri}
            />
            <div className="content">{e.content ? <e.content /> : null}</div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
